import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom-v5-compat';

import { buildRoutes } from '../constants/routes';

type ProfileRoutes = ReturnType<typeof buildRoutes>;

export const useProfileRoutes = (): ProfileRoutes => {
  const location = useLocation();
  const { serviceSlug } = useParams<{ serviceSlug?: string }>();

  const isEpsu = location.pathname.includes('/existing-provider-sign-up/');

  return buildRoutes(isEpsu ? serviceSlug : undefined);
};
